/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Action_LabelInputs */



/**
* | output |
* | --- |
* | "Import Subtitles" |
*
* @param {Subtitle_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_action_label = /** @type {((inputs?: Subtitle_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕をインポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar legendas")
	return /** @type {LocalizedString} */ ("Import Subtitles")
});